/**
 * URL sanitization and helper utilities
 */

export const sanitizeUrl = (url: string): string => {
  if (!url || typeof url !== 'string') return '';
  
  try {
    // Fix multiple question marks and malformed parameters
    let sanitized = url.replace(/\?\?+/g, '?');
    
    // Remove duplicate parameters
    const urlParts = sanitized.split('?');
    if (urlParts.length > 1) {
      const baseUrl = urlParts[0];
      const queryParams = urlParts[1];
      
      // Parse and deduplicate parameters
      const params = new URLSearchParams();
      queryParams.split('&').forEach(param => {
        const [key, value] = param.split('=');
        if (key && value !== undefined) {
          params.set(key, value);
        }
      });
      
      sanitized = `${baseUrl}?${params.toString()}`;
    }
    
    // Validate URL structure
    new URL(sanitized);
    return sanitized;
  } catch (error) {
    console.warn('Failed to sanitize URL:', url, error);
    return url; // Return original if sanitization fails
  }
};

export const addCacheBuster = (url: string): string => {
  if (!url) return '';
  
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}_cb=${Date.now()}`;
};

export const isValidImageUrl = (url: string): boolean => {
  if (!url || typeof url !== 'string') return false;
  
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname.toLowerCase();
    return /\.(jpg|jpeg|png|gif|webp|svg|bmp|tiff|ico|heic|heif)(\?|$)/i.test(pathname) ||
           url.includes('supabase') || // Supabase storage URLs
           url.includes('blob:') ||    // Blob URLs
           url.includes('data:image'); // Data URLs
  } catch {
    return false;
  }
};
